import React from "react";
import { useUserContext } from "context/UserContext";
import EmployeeManagementBK from "layouts/BK/employee";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function EmployeeManagement() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <EmployeeManagementBK />;
  }
  return null;
}

export default EmployeeManagement;
